"use client";
import React, { useEffect, useRef } from "react";
import { tsParticles } from "tsparticles-engine";
import { loadSlim } from "tsparticles-slim";

export const SparklesCore = ({
  id,
  background = "transparent",
  minSize = 0.8,
  maxSize = 2,
  particleDensity = 100,
  particleColor = "#ffffff",
  className,
}) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const initParticles = async () => {
      await loadSlim(tsParticles);

      await tsParticles.load({
        id: id || "tsparticles",
        options: {
          background: { color: { value: background } },
          fpsLimit: 60,
          particles: {
            color: { value: particleColor },
            move: {
              direction: "none",
              enable: true,
              outModes: { default: "out" },
              random: true,
              speed: 1,
              straight: false,
            },
            number: {
              density: { enable: true, area: 800 },
              value: particleDensity,
            },
            opacity: {
              value: { min: 0.2, max: 0.5 },
              animation: { enable: true, speed: 0.2, sync: false },
            },
            shape: { type: "circle" },
            size: {
              value: { min: minSize, max: maxSize },
              animation: { enable: true, speed: 2, sync: false },
            },
          },
          detectRetina: true,
        },
      });
    };

    initParticles();

    // nettoyage quand le composant est démonté
    return () => {
      tsParticles.dom().forEach((p) => p.destroy());
    };
  }, [id, background, minSize, maxSize, particleDensity, particleColor]);

  return <div ref={containerRef} id={id} className={className}></div>;
};
